import React from "react";
import { Spinner } from "react-bootstrap";
const styles = require("./styles.scss");
const SpinnerLoader = () => {
    return (React.createElement("div", { className: styles.spinnerWrapper },
        React.createElement(Spinner, { animation: "border", variant: "primary" })));
};
export default SpinnerLoader;
